import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import { TooltipsService } from '../../services/tooltips.service';
import { AnalyticsService } from '../../services/analytics.service';
import './unsubscribe-basic.component.scss';
var UnsubscribeBasic = /** @class */ (function (_super) {
    tslib_1.__extends(UnsubscribeBasic, _super);
    function UnsubscribeBasic(element) {
        return _super.call(this, element) || this;
    }
    UnsubscribeBasic.prototype.init = function () {
        this.containerUnsubscribe = this.element.querySelector('.unsubscribe-basic__container--change');
        this.containerNotValid = this.element.querySelector('.unsubscribe-basic__container--notvalid');
        this.containerCancelled = this.element.querySelector('.unsubscribe-basic__container--cancelled');
        this.containerLoader = this.element.querySelector('.unsubscribe-basic__container--loader');
        this.btnUnsubscribe = this.element.querySelector('.unsubscribe-basic__button--unsubscribe');
        TooltipsService.initTooltips();
    };
    UnsubscribeBasic.prototype.bindEvents = function () {
        var _this = this;
        this.btnUnsubscribe.addEventListener('click', function (event) {
            var element = event.target;
            var form = element.closest('form');
            _this.unsubscribe(form);
        });
    };
    UnsubscribeBasic.prototype.unsubscribe = function (form) {
        var _this = this;
        this.containerUnsubscribe.classList.remove('d-block');
        this.containerNotValid.classList.remove('d-block');
        this.containerCancelled.classList.remove('d-block');
        this.containerLoader.classList.add('d-block');
        var operation = "unsubscribe";
        var formId = form.querySelector('input.js-unsubscribe-formid').value;
        var subId = form.querySelector('input.js-unsubscribe-subid').value;
        var siteName = form.querySelector('input.js-unsubscribe-sitename').value;
        var mcJobId = form.querySelector('input.js-unsubscribe-mcjobid').value;
        var mcBatchId = form.querySelector('input.js-unsubscribe-mcbatchid').value;
        var postData = '';
        if (operation) {
            postData += 'operation=' + operation + '&';
        }
        if (formId) {
            postData += 'formId=' + formId + '&';
        }
        if (subId) {
            postData += 'subId=' + subId + '&';
        }
        if (siteName) {
            postData += 'site=' + siteName + '&';
        }
        if (mcJobId) {
            postData += 'mcJobID=' + mcJobId + '&';
        }
        if (mcBatchId) {
            postData += 'mcBatchID=' + mcBatchId + '&';
        }
        postData += 'optOut=';
        var analyticsService = new AnalyticsService();
        var url = "/services/NewsLetterSubscription.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, postData, config).then(function (response) {
            _this.containerLoader.classList.remove('d-block');
            if (response.data.result) {
                var result = response.data.result;
                if (result.indexOf('unsubscribed') !== -1) {
                    if (localStorage.getItem('sbgNewsletterSubscriberId')) {
                        localStorage.removeItem('sbgNewsletterSubscriberId');
                    }
                    analyticsService.dtmFormComplete('complete', response.data.subscriberId);
                    _this.containerUnsubscribe.classList.remove('d-block');
                    _this.containerCancelled.classList.add('d-block');
                }
                else {
                    _this.containerUnsubscribe.classList.remove('d-block');
                    _this.containerNotValid.classList.add('d-block');
                }
            }
            else {
                _this.containerUnsubscribe.classList.remove('d-block');
                _this.containerNotValid.classList.add('d-block');
            }
        }).catch(function (error) {
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            console.log(error);
            _this.containerLoader.classList.remove('d-block');
            _this.containerUnsubscribe.classList.remove('d-block');
            _this.containerNotValid.classList.add('d-block');
        });
    };
    return UnsubscribeBasic;
}(Base));
export { UnsubscribeBasic };



//////////////////
// WEBPACK FOOTER
// ./components/unsubscribe-basic/unsubscribe-basic.component.ts
// module id = 549
// module chunks = 0